"use client"

import { Button } from "@/components/ui/button"

interface Account {
  id: string
  name: string
  type: string
  count: number
}

interface AccountSelectionProps {
  accounts: Account[]
  selectedAccounts: string[]
  onToggleAccount: (accountId: string) => void
}

export function AccountSelection({ 
  accounts, 
  selectedAccounts, 
  onToggleAccount 
}: AccountSelectionProps) {
  // Count only actual branches (exclude "all")
  const branchCount = selectedAccounts.filter(id => id !== "all").length
  
  return (
    <div className="mb-6">
      <div className="flex items-center justify-between mb-3">
        <label className="text-sm font-medium text-gray-900">
          เลือกสาขาที่ใช้บัญชีนี้
        </label>              
        <span className="text-sm">
          <span className="text-red-500">{branchCount}</span>
          &nbsp;สาขา
        </span>
      </div>

      <div className="space-y-2">
        {accounts.map((account) => (
          <div
            key={account.id}
            className="flex items-center justify-between p-3 bg-gray-100 rounded-lg"
          >
            <div className="flex items-center gap-3">
              {account.type === "all" && (
                <div className="w-10 h-10 rounded-full bg-green-500 flex items-center justify-center text-white font-semibold">
                  ALL
                </div>
              )}
              {account.type !== "all" && (
                <div className="w-10 h-10 rounded-full text-green-500 flex items-center justify-center bg-white font-semibold text-2xl">
                  1
                </div>
              )}
              <div>
                <div className="text-sm font-medium text-gray-900">
                  {account.name}
                </div>
                <div className="text-xs text-gray-500">
                  {account.type === "all" ? `ครอบคลุม ${account.count} บัญชีในระบบ` : `มี ${account.count} บัญชี`}
                </div>
              </div>
            </div>
            <div className="flex items-center gap-2">
              {account.type === "bank" && (
                <>
                  <img src="/icons/icon-line-oa.svg" alt="Line OA" />
                  <img src="/icons/icon-line.svg" alt="Line" />
                  <img src="/icons/icon-line-chat.svg" alt="Line Chat" />
                </>
              )}
              <Button
                variant="outline"
                size="sm"
                onClick={() => onToggleAccount(account.id)}
                className={`min-w-[60px] rounded-2xl ${
                  selectedAccounts.includes(account.id)
                    ? "bg-brand-primary text-white border-brand-primary"
                    : "bg-gray-200 text-gray-600 border-transparent"
                }`}
              >
                {selectedAccounts.includes(account.id) ? "✓ เลือกแล้ว" : "เลือก"}
              </Button>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
